/** This class is to maintain the api service properties in a single place.
 * example service object
 * "serviceName": {
 *      url: string;
 *      method: string;
 *      showSpinner?: boolean;
 *      showSuccessMsg?: boolean;
 *      showErrorMsg?: boolean;
 *      successMsg?: string;
 *      errorMsg?: string;
 *      headers?: any;
 * }
 */
 import { BaseApiConstants } from './core/base-api-constants';

 export class ApiConstants extends BaseApiConstants {
    public static readonly login: any = {
        url: 'appuserprivileges/authenticate',
        method: 'GET',
        showloading: true
    };
    public static readonly fslogin: any = {
        url: 'firebase/usertoken',
        method: 'GET',
        showloading: true
    };
        public static readonly getUserBlackListAll_UserBlackList: any = {
        url: 'userblacklists/userblacklists/datatable',
        method: 'POST',
        showloading: true
    };
    public static readonly createUserBlackList: any = {
        url: 'userblacklists',
        method: 'POST',
        showloading: true
    };
    public static readonly deleteUserBlackList: any = {
        url: 'userblacklists/{ids}',
        method: 'DELETE',
        showloading: true
    };
    public static readonly deleteFieldsUserBlackList: any = {
        url: 'userblacklists/deletefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly updateUserBlackList: any = {
        url: 'userblacklists',
        method: 'PUT',
        showloading: true
    };
    public static readonly updateFieldsUserBlackList: any = {
        url: 'userblacklists/updatefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly getUserBlackListBySid: any = {
        url: 'userblacklists/sid/{sid}',
        method: 'GET',
        showloading: true
    };
    public static readonly createUserInformation: any = {
        url: 'userinformations',
        method: 'POST',
        showloading: true
    };
    public static readonly deleteUserInformation: any = {
        url: 'userinformations/{ids}',
        method: 'DELETE',
        showloading: true
    };
    public static readonly updateUserInformation: any = {
        url: 'userinformations',
        method: 'PUT',
        showloading: true
    };
    public static readonly autoSuggestService_UserInformation: any = {
        url: 'userinformations/autosuggestservice',
        method: 'GET',
        showloading: true
    };
    public static readonly getUserInformationBySid: any = {
        url: 'userinformations/sid/{sid}',
        method: 'GET',
        showloading: true
    };
    public static readonly deleteFieldsUserInformation: any = {
        url: 'userinformations/deletefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly updateFieldsUserInformation: any = {
        url: 'userinformations/updatefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly getUserInformationAll_UserInformation: any = {
        url: 'userinformations/userinformations/datatable',
        method: 'POST',
        showloading: true
    };
    public static readonly getSolvayCompanyAll_SolvayCompany: any = {
        url: 'solvaycompanies/solvaycompanies/datatable',
        method: 'POST',
        showloading: true
    };
    public static readonly autoSuggestService_SolvayCompany: any = {
        url: 'solvaycompanies/autosuggestservice',
        method: 'GET',
        showloading: true
    };
    public static readonly deleteFieldsSolvayCompany: any = {
        url: 'solvaycompanies/deletefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly deleteSolvayCompany: any = {
        url: 'solvaycompanies/{ids}',
        method: 'DELETE',
        showloading: true
    };
    public static readonly updateFieldsSolvayCompany: any = {
        url: 'solvaycompanies/updatefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly createSolvayCompany: any = {
        url: 'solvaycompanies',
        method: 'POST',
        showloading: true
    };
    public static readonly updateSolvayCompany: any = {
        url: 'solvaycompanies',
        method: 'PUT',
        showloading: true
    };
    public static readonly getSolvayCompanyBySid: any = {
        url: 'solvaycompanies/sid/{sid}',
        method: 'GET',
        showloading: true
    };
    public static readonly createCompanyAuthorization: any = {
        url: 'companyauthorizations',
        method: 'POST',
        showloading: true
    };
    public static readonly updateFieldsCompanyAuthorization: any = {
        url: 'companyauthorizations/updatefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly updateCompanyAuthorization: any = {
        url: 'companyauthorizations',
        method: 'PUT',
        showloading: true
    };
    public static readonly deleteCompanyAuthorization: any = {
        url: 'companyauthorizations/{ids}',
        method: 'DELETE',
        showloading: true
    };
    public static readonly getCompanyAuthorizationBySid: any = {
        url: 'companyauthorizations/sid/{sid}',
        method: 'GET',
        showloading: true
    };
    public static readonly getCompanyAuthorizationAll_CompanyAuthorization: any = {
        url: 'companyauthorizations/companyauthorizations/datatable',
        method: 'POST',
        showloading: true
    };
    public static readonly deleteFieldsCompanyAuthorization: any = {
        url: 'companyauthorizations/deletefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly updateAppUserPrivileges: any = {
        url: 'appuserprivileges',
        method: 'PUT',
        showloading: true
    };
    public static readonly getCurrentUser: any = {
        url: 'appuserprivileges/authenticate',
        method: 'GET',
        showloading: true
    };
    public static readonly getAppUserPrivilegesBySid: any = {
        url: 'appuserprivileges/sid/{sid}',
        method: 'GET',
        showloading: true
    };
    public static readonly getAppUserPrivilegesByEmail: any = {
        url: 'appuserprivileges/email/{email}',
        method: 'GET',
        showloading: true
    };
    public static readonly getAppUserPrivilegesAll_AppUserPrivileges: any = {
        url: 'appuserprivileges/appuserprivileges/datatable',
        method: 'POST',
        showloading: true
    };
    public static readonly deleteAppUserPrivileges: any = {
        url: 'appuserprivileges/{ids}',
        method: 'DELETE',
        showloading: true
    };
    public static readonly updateActualUser: any = {
        url: 'appuserprivileges/updateactualuser/{actualuser}',
        method: 'GET',
        showloading: true
    };
    public static readonly createAppUserPrivileges: any = {
        url: 'appuserprivileges',
        method: 'POST',
        showloading: true
    };
    public static readonly getUserWhiteListBySid: any = {
        url: 'userwhitelists/sid/{sid}',
        method: 'GET',
        showloading: true
    };
    public static readonly getUserWhiteListAll_UserWhiteList: any = {
        url: 'userwhitelists/userwhitelists/datatable',
        method: 'POST',
        showloading: true
    };
    public static readonly updateUserWhiteList: any = {
        url: 'userwhitelists',
        method: 'PUT',
        showloading: true
    };
    public static readonly deleteFieldsUserWhiteList: any = {
        url: 'userwhitelists/deletefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly deleteUserWhiteList: any = {
        url: 'userwhitelists/{ids}',
        method: 'DELETE',
        showloading: true
    };
    public static readonly createUserWhiteList: any = {
        url: 'userwhitelists',
        method: 'POST',
        showloading: true
    };
    public static readonly updateFieldsUserWhiteList: any = {
        url: 'userwhitelists/updatefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly deleteSyncRecord: any = {
        url: 'syncrecords/{ids}',
        method: 'DELETE',
        showloading: true
    };
    public static readonly createSyncRecord: any = {
        url: 'syncrecords',
        method: 'POST',
        showloading: true
    };
    public static readonly getSyncRecordBySid: any = {
        url: 'syncrecords/sid/{sid}',
        method: 'GET',
        showloading: true
    };
    public static readonly updateFieldsSyncRecord: any = {
        url: 'syncrecords/updatefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly deleteFieldsSyncRecord: any = {
        url: 'syncrecords/deletefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly updateSyncRecord: any = {
        url: 'syncrecords',
        method: 'PUT',
        showloading: true
    };
    public static readonly deleteFieldsSolvaySite: any = {
        url: 'solvaysites/deletefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly updateSolvaySite: any = {
        url: 'solvaysites',
        method: 'PUT',
        showloading: true
    };
    public static readonly deleteSolvaySite: any = {
        url: 'solvaysites/{ids}',
        method: 'DELETE',
        showloading: true
    };
    public static readonly getSolvaySiteBySid: any = {
        url: 'solvaysites/sid/{sid}',
        method: 'GET',
        showloading: true
    };
    public static readonly updateFieldsSolvaySite: any = {
        url: 'solvaysites/updatefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly getSolvaySiteAll_SolvaySite: any = {
        url: 'solvaysites/solvaysites/datatable',
        method: 'POST',
        showloading: true
    };
    public static readonly createSolvaySite: any = {
        url: 'solvaysites',
        method: 'POST',
        showloading: true
    };
    public static readonly getResultsBySid: any = {
        url: 'results/sid/{sid}',
        method: 'GET',
        showloading: true
    };
    public static readonly createResults: any = {
        url: 'results',
        method: 'POST',
        showloading: true
    };
    public static readonly getResultsAll_Results: any = {
        url: 'results/results/datatable',
        method: 'POST',
        showloading: true
    };
    public static readonly deleteResults: any = {
        url: 'results/{ids}',
        method: 'DELETE',
        showloading: true
    };
    public static readonly updateResults: any = {
        url: 'results',
        method: 'PUT',
        showloading: true
    };
    public static readonly deleteFieldsResults: any = {
        url: 'results/deletefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly updateFieldsResults: any = {
        url: 'results/updatefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly getChangelog: any = {
        url: 'changelogs/datatable/{entityName}/{entityId}/{fieldName}/{fromModifiedDate}',
        method: 'POST',
        showloading: true
    };
    public static readonly createControlGroupCountry: any = {
        url: 'controlgroupcountries',
        method: 'POST',
        showloading: true
    };
    public static readonly updateControlGroupCountry: any = {
        url: 'controlgroupcountries',
        method: 'PUT',
        showloading: true
    };
    public static readonly getControlGroupCountryAll_ControlGroupCountry: any = {
        url: 'controlgroupcountries/controlgroupcountries/datatable',
        method: 'POST',
        showloading: true
    };
    public static readonly getControlGroupCountryBySid: any = {
        url: 'controlgroupcountries/sid/{sid}',
        method: 'GET',
        showloading: true
    };
    public static readonly deleteControlGroupCountry: any = {
        url: 'controlgroupcountries/{ids}',
        method: 'DELETE',
        showloading: true
    };
    public static readonly updateFieldsControlGroupCountry: any = {
        url: 'controlgroupcountries/updatefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly deleteFieldsControlGroupCountry: any = {
        url: 'controlgroupcountries/deletefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly deleteFieldsControlGroup: any = {
        url: 'controlgroups/deletefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly autoSuggestService_ControlGroup: any = {
        url: 'controlgroups/autosuggestservice',
        method: 'GET',
        showloading: true
    };
    public static readonly updateControlGroup: any = {
        url: 'controlgroups',
        method: 'PUT',
        showloading: true
    };
    public static readonly getControlGroupAll_ControlGroup: any = {
        url: 'controlgroups/controlgroups/datatable',
        method: 'POST',
        showloading: true
    };
    public static readonly updateFieldsControlGroup: any = {
        url: 'controlgroups/updatefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly createControlGroup: any = {
        url: 'controlgroups',
        method: 'POST',
        showloading: true
    };
    public static readonly deleteControlGroup: any = {
        url: 'controlgroups/{ids}',
        method: 'DELETE',
        showloading: true
    };
    public static readonly getControlGroupBySid: any = {
        url: 'controlgroups/sid/{sid}',
        method: 'GET',
        showloading: true
    };
    public static readonly deleteSyncRecordDetails: any = {
        url: 'syncrecorddetails/{ids}',
        method: 'DELETE',
        showloading: true
    };
    public static readonly deleteFieldsSyncRecordDetails: any = {
        url: 'syncrecorddetails/deletefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly updateFieldsSyncRecordDetails: any = {
        url: 'syncrecorddetails/updatefields',
        method: 'PUT',
        showloading: true
    };
    public static readonly updateSyncRecordDetails: any = {
        url: 'syncrecorddetails',
        method: 'PUT',
        showloading: true
    };
    public static readonly createSyncRecordDetails: any = {
        url: 'syncrecorddetails',
        method: 'POST',
        showloading: true
    };
    public static readonly getSyncRecordDetailsBySid: any = {
        url: 'syncrecorddetails/sid/{sid}',
        method: 'GET',
        showloading: true
    };
    public static readonly getAppUsersReportExcel: any = {
        url: 'appuserprivileges/export',
        method: 'GET',
        showloading: true
    };
    public static readonly getResultReportExcel: any = {
        url: 'results/export',
        method: 'POST',
        showloading: true
    };
    public static readonly getCompanyReportExcel: any = {
        url: 'solvaycompanies/export',
        method: 'GET',
        showloading: true
    };
    public static readonly getSiteReportExcel: any = {
        url: 'solvaysites/export',
        method: 'GET',
        showloading: true
    };
    public static readonly getUserInfoReportExcel: any = {
        url: 'userinformations/export',
        method: 'GET',
        showloading: true
    };
    public static readonly getWhitelistReportExcel: any = {
        url: 'userwhitelists/export',
        method: 'GET',
        showloading: true
    };
    public static readonly getControlgroupReportExcel: any = {
        url: 'controlgroups/export',
        method: 'GET',
        showloading: true
    };
    public static readonly getControlgroupcountryReportExcel: any = {
        url: 'controlgroupcountries/export',
        method: 'GET',
        showloading: true
    };
    public static readonly getImportStatus: any = {
        url: 'import/status',
        method: 'GET',
        showloading: true
    };
    public static readonly getChangeLog: any = {
        url: 'changeResults/datatable',
        method: 'POST',
        showloading: true
    };
    public static readonly getChangeLogReportExcel: any = {
        url: 'changeResults/export',
        method: 'POST',
        showloading: true
    };
    public static readonly getSftpDashboard: any = {
        url: 'sftpdashboard/datatable',
        method: 'POST',
        showloading: true
    };
    public static readonly getDailySyncDashboard: any = {
        url: 'dailysyncdashboard/datatable',
        method: 'POST',
        showloading: true
    };
    public static readonly getsapDetail: any = {
        url: 'sapdetails/{userid}',
        method: 'POST',
        showloading: true
    };
 }
